import { colors } from "./colors";
import { mediaQueries } from "./mediaQueries";
import { vars } from "./vars";
import { queries, viewports } from "./viewports";

export const style = {
  colors,
  mediaQueries,
  vars,
  viewports,
  queries,
};

export { extractFlatColor, type FlatColorMap } from "./color-helpers";
export { WalrusGlobalStyle } from "./global-style";
export { MockMediaQueryViewportProvider } from "./MockMediaQueryViewportProvider";
export { stylesheet as __INTERNAL_global_stylesheet__ } from "./stylesheet.compiled";
export { createMediaQuery as __INTERNAL_createMediaQuery__, type MediaQueryWrapper } from "./utils/createMediaQuery";
export { mediaQueries };
export { useGetBoundingClientRectRef, useGetBoundingClientRect, MockGetBoundingClientRectProvider } from "./useGetBoundingClientRect";
export { useScrollIntoView, MockScrollIntoViewProvider } from "./useScrollIntoView";
export { type IconName } from "./icons";
